import { useRef, useState, useEffect } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import styles from './AccessLinkQrModal.module.css';

const AccessLinkQrModal = ({ url, onClose, note }) => {
  const canvasContainerRef = useRef(null);
  const [copied, setCopied] = useState(false);

  // Закрытие по Esc
  useEffect(() => {
    const handler = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [onClose]);

  const handleDownload = () => {
    const canvas = canvasContainerRef.current?.querySelector('canvas');
    if (!canvas) return;

    const dataUrl = canvas.toDataURL('image/png');
    const a = document.createElement('a');
    a.href = dataUrl;
    a.download = `access-link-qr-${Date.now()}.png`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      alert('Не удалось скопировать ссылку');
    }
  };

  return (
    <div
      className={styles.overlay}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className={styles.modal}>
        <button className={styles.closeBtn} onClick={onClose}>✕</button>

        <h2 className={styles.title}>QR-код ссылки</h2>
        {note && <p className={styles.note}>{note}</p>}

        <div className={styles.qrWrap} ref={canvasContainerRef}>
          <QRCodeCanvas
            value={url}
            size={256}
            level="M"
            marginSize={2}
            bgColor="#ffffff"
            fgColor="#111827"
          />
        </div>

        <div className={styles.urlBox}>
          <code className={styles.url}>{url}</code>
        </div>

        <div className={styles.actions}>
          <button className={styles.primaryBtn} onClick={handleDownload}>
            ⬇ Скачать PNG
          </button>
          <button className={styles.secondaryBtn} onClick={handleCopy}>
            {copied ? '✓ Скопировано' : 'Копировать URL'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccessLinkQrModal;
